<template>
  <div class="dashboard_card_root">
    <router-link
      :to="rallyUrl"
      class="dashboard_card dashboard_card--clickable"
      :tabindex="0"
    >
      <div
        v-if="iconPath"
        class="dashboard_card_icon_type"
      >
        <img
          :src="iconPath"
          alt=""
        >
      </div>
      <div class="dashboard_card_container">
        <div class="dashboard_card_imgwrapper">
          <img
            :src="displayImage"
            class="dashboard_card_img"
            @error="onImageError"
          >
        </div>
        <div class="dashboard_card_content">
          <div class="dashboard_card_content_header">
            <TextHighlight :query-string="queryString">
              {{ rally.attributes.title }}
            </TextHighlight>
          </div>
          <p class="dashboard_cardOrgDesc">
            <TextHighlight :query-string="queryString">
              {{ rally.attributes.description }}
            </TextHighlight>
          </p>
          <span
            v-if="memberLabel"
            class="dashboard_card_content_member"
          >
            <i class="fas fa-user-friends" />
            {{ memberLabel }}
          </span>
          <button
            v-if="specialAction == 'accept'"
            type="button"
            class="dashboard_card_accept_invitation_btn"
          >
            <i class="fas fa-envelope-circle-check" />
            Accept Invite
          </button>
          <button
            v-else-if="specialAction == 'unarchive'"
            type="button"
            class="dashboard_card_accept_invitation_btn"
            @click.prevent="unarchiveRally"
          >
            Unarchive Rally
          </button>
          <button
            v-else-if="specialAction == 'join'"
            type="button"
            class="dashboard_card_join_btn"
          >
            <i class="fas fa-plus" />
            Join Rally
          </button>
          <button
            v-else-if="specialAction == 'request'"
            type="button"
            class="dashboard_card_join_btn"
          >
            <i class="fas fa-paper-plane" />
            Send Request
          </button>
          <i
            v-else
            class="fa-star fav_btn"
            :class="isFavorite ? 'fas fav_btn_active' : 'far fav_btn_disable'"
            role="button"
            :aria-label="isFavorite ? 'Remove favorite' : 'Add favorite'"
            @click.prevent="toggleFavoriteState"
          />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { router } from '../common'
  import TextHighlight from './TextHighlight.vue'

  export default {
    name: 'DashboardCard',
    components: { TextHighlight },
    props: {
      membership: { type: Object, default: null },
      queryString: { type: String, default: '' },
      rally: { type: Object, required: true },
    },
    data() {
      return {
        defaultImage: '/images/dg_rally_avatar.png',
        imageLoadFailed: false,
      };
    },
    computed: {
      ...mapState('contents', ['contentById']),
      ...mapState("rallies", ["rallyChannelsByRallyId"]),
      displayImage() {
        const avatarId = this.rally?.relationships?.avatar.data.id || -1
        const avatarImage = ( avatarId == -1 ) ? this.defaultImage : this.contentById[avatarId]
        const avatarUrl = ( avatarImage.attributes && avatarImage.attributes['small-url'] ) ? avatarImage.attributes['small-url'] : null

        return ( avatarUrl && !this.imageLoadFailed ) ? avatarUrl : this.defaultImage
      },
      iconPath() {
        const hubIcon = "/icons/hub_circle.svg"
        const rallyIcon = "/icons/rally_circle.svg"
        return this.rally.attributes['is-hub'] ? hubIcon : rallyIcon
      },
      isFavorite() {
        return this.rally.attributes['is-user-favorite']
      },
      memberLabel() {
        const count = ( this.rally.attributes['member-count'] || 0).toString()
        const pluralize = count === '1' ? '' : 's'

        return ( count === '0' ) ? '' : `${count.toLocaleString()} Member${pluralize}`
      },
      rallyUrl() {
        return this.rally.attributes.viewable ? `/${this.rally.id}` : `/${this.rally.id}/gate`
      },
      specialAction() {
        if ( this.membership ) {
          if ( this.rally.attributes.status == 'Archived' && this.rally.attributes.deletable ) {
            return 'unarchive'
          }
          else if ( this.membership.attributes.status == 'Invited' ) {
            return 'accept'
          }
        } else if ( this.rally.attributes.viewable == true ) {
          // User has implicit access, but no explicit membership.
          return null
        } else {
          return { 'Public': 'join', 'Private': 'request' }[this.rally.attributes.privacy]
        }

        return null
      }
    },
    methods: {
      ...mapActions("rallies", ["toggleFavorite", "updateRally"]),
      onImageError() {
        this.imageLoadFailed = true
      },
      unarchiveRally() {
        this.updateRally({rally: { rally: this.rally }, status:"Active"})

        // Instantly reflect the change without waiting for response from server.
        // eslint-disable-next-line vue/no-mutating-props
        this.rally.attributes['status'] = 'Active'

        this.$store.dispatch('user/flashSuccess', 'Rally successfully unarchived')
      },
      toggleFavoriteState() {
        const action = this.isFavorite ? 'unfavorite' : 'favorite'
        // Instantly reflect the change without waiting for response from server.
        // eslint-disable-next-line vue/no-mutating-props
        this.rally.attributes['is-user-favorite'] = !this.isFavorite
        this.toggleFavorite({action: action, rallyId: this.rally.id})
      },
    },
  };
</script>
